const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/task-assignment/index.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/task-assignment/index.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { TaskAssignmentListSkeleton } from '@/features/task-assignment/components/TaskAssignmentListSkeleton';
import { taskAssignmentSearchToFilters } from '@/features/task-assignment/lib/taskAssignmentSearch';
import { taskRequestsQuery } from '@/features/task-assignment/services/taskAssignmentQueries';
import { taskAssignmentSearchSchema } from '@/features/task-assignment/types/taskAssignment';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Supervisor → Task Assignment list. The cold first page is warmed without a
 * required project id; project inventory is an independent optional filter source.
 */
export const Route = createFileRoute('/_authenticated/_app/supervisor/task-assignment/')({
  validateSearch: taskAssignmentSearchSchema,
  loaderDeps: ({
    search
  }) => taskAssignmentSearchToFilters(search),
  loader: async ({
    cause,
    context,
    deps
  }) => {
    const query = taskRequestsQuery(deps);
    const hasCachedData = context.queryClient.getQueryState(query.queryKey)?.data !== undefined;
    if (cause === 'enter' && !hasCachedData) {
      await context.queryClient.ensureInfiniteQueryData(query);
    }
  },
  shouldReload: false,
  pendingComponent: TaskAssignmentListSkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});